<template>
  <div class="container">
    <Header></Header>
    <HeaderMobile></HeaderMobile>
    <div class="fp-container">
      <div class="fp-right">
        <div class="fp-right-overlay"></div>

        <AuthCardTwo
          head="New Here?"
          subhead="Get ready to kiss your captcha troubles goodbye."
          buttonText="Create An Account"
          @clicked="handleCreateAccount"
        ></AuthCardTwo>
      </div>
      <div class="fp-left">
        <h1>Forgot Your Password?</h1>
        <h5>Please enter a new password for your account</h5>

        <div class="auth-input-section">
          <InputWidget @changed="handlePasswordChanged" :isPassword="true" placeholder="Password"></InputWidget>
          <InputWidget
            @changed="handleConfirmPasswordChanged"
            :isPassword=true
            placeholder="Confirm Password"
            style="margin-bottom: 0px !important"
          ></InputWidget>
         
          <ButtonFilled @onButtonClicked="handlePasswordReset" :text="btnStatus"></ButtonFilled>
          <div class="error-message" v-html="errorMessage"></div>
           <div v-if="isSuccess" class="success-message">Password reset successful, you can <router-link to="/login">login</router-link> now.  </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable -->

<script>
import AuthHead from "../../../components/auth/AuthHead";
import AuthCardTwo from "../../../components/auth/AuthCardTwo";
import InputWidget from "../../../components/common/InputWidget";
import ButtonFilled from "../../../components/common/ButtonFilled";
import ThirdParty from "../../../components/auth/ThirdParty";
import CheckBox from "../../../components/common/Checkbox";
import ButtonOutlinedScroll from "../../../components/common/ButtonOutlinedScroll";
import Header from "../../../components/landing/Header";
import HeaderMobile from "../../../components/landing/HeaderMobile";
import { handleResetPassword } from "../../../service/user";

export default {
  components: {
    AuthHead,
    AuthCardTwo,
    InputWidget,
    ButtonFilled,
    ThirdParty,
    CheckBox,
    ButtonOutlinedScroll,
    Header,
    HeaderMobile,
  },
  data() {
    return {
      headline: "",
      email: "",
      password: "",
      cPassword: "",
      btnStatus: "Submit",
      isSuccess: false,
      rememberMe: false,
      tok: '',
      errorMessage: "",
    };
  },

  mounted() {
    window.scroll(0, 0);
    this.tok = window.location.href.split('?')[1]
  },

  methods: {
    handleCreateAccount(){
      this.$router.push('register')
    },
    validatePassword(password) {
      var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (reg.test(password) == false) {
        return false;
      }
      return true;
    },
    scrollDown() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    
    handlePasswordChanged(password) {
      this.password = password;
    },
    handleConfirmPasswordChanged(cpassword) {
      this.cPassword = cpassword;
    },
   
    async handlePasswordReset() {
      this.errorMessage = "";
      this.isSuccess = false;
      if (
        this.validatePassword(this.password)
        && this.password === this.cPassword
      ) {
        this.btnStatus = "Wait...";
        try {
          const res = await handleResetPassword(
            this.tok,
            this.password,
          );
          if (res.data.code == 200) {
            this.isSuccess = true;
            this.btnStatus = "Submit"
           
          } else {
            this.btnStatus = "Submit";
            this.errorMessage = res.data.message;
          }
        } catch (e) {
          this.btnStatus = "Submit";
          this.errorMessage = e.message;
        }
      } else {
        if(this.password !== this.cpassword){
           this.errorMessage +=
            "- Password doesn't match" +
            "<br/>";
        }
        if (!this.validatePassword(this.password)) {
          this.errorMessage +=
            "- password must be of minimum eight characters, at least one letter, one number and one special character" +
            "<br/>";
        }
      }
    },
  },
};
</script>

<style scoped>
.container {
  margin: auto;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 95%;
  height: 1000px;
  margin: auto;
  margin-top: 14px;
  margin-bottom: 14px;
}

.auth-head {
  margin-top: 25px !important;
}

.fp-container {
  background-color: #1a1c1f;
  border-radius: 7px;
  width: 976px;
  box-shadow: 2px 2px 5px #0000002a;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 180% 170% at top,
    #26292e 0.4%,
    #1a1c1f 100%
  );
  transition: 0.3s;
}

.fp-left {
  flex: 0.6;
  max-width: 60%;
  height: 568px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
  justify-content: center;
}

.fp-left > h1 {
  color: #e0e0e0;
  margin-bottom: 24px;
  text-align: center;
}

.fp-left > h5 {
  font-size: 12px;
  line-height: 16px;
  color: #888888;
  margin-bottom: 32px;
  text-align: center;

}

.button-filled{
    margin-top: 32px !important;
}

.fp-right {
  position: relative;
  flex: 0.4;
  max-width: 40%;
  height: 568px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 300% 150% at right bottom,
    #26292e 0.04%,
    #1a1c1f 100%
  );
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  transition: 0.3s;
}

.fp-right-overlay {
  position: absolute;
  background: url("../../../assets/img/dom-labs.svg");
  background-repeat: no-repeat;
  background-size: auto;
  height: 100%;
  width: 100%;
}

.login-reset-password,
.keep-me-logged-in > p {
  color: #888888;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

.keep-me-logged-in {
  margin-bottom: 18px;
  margin-top: 6px;
}

.auth-input-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60%;
}

.input-widget {
  margin-top: 0px !important;
  width: 80% !important;
}

@media only screen and (max-width: 786px) {
  #headerWeb {
    display: none !important;
  }
  #landingHeaderMobile {
    display: block !important;
  }
}

@media only screen and (max-width: 750px) {
  .fp-left,
  .fp-right {
    flex: 50% !important;
    max-width: 50% !important;
    width: 50%;
  }

  .auth-input-section {
    width: 90% !important;
  }

  input {
    width: 230px;
  }

  .fp-container {
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 610px) {
  .container {
    height: 100% !important;
  }
  .fp-left,
  .fp-right {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100%;
  }

  .fp-right {
    border-radius: 0 !important;
    border-bottom-right-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    order: 1;
  }

  input {
    width: 230px;
  }

  .fp-container {
    flex-wrap: wrap !important;
  }

  .fp-left {
    height: 95vh;
    justify-content: center;
  }

  #fpHidden {
    display: flex !important;
    margin-top: 200px !important;
  }
}
</style>